<template>
  <div class="isTxt" v-if="isTxt">
    {{ innerValue || '-' }}
  </div>
  <template v-else>
    <RxkInput
      style="width: 30%"
      v-model="innerValue1"
      :type="renderConfig.inputType"
      :disabled="renderConfig.disabled"
      placeholder="请输入区号"
      :maxlength="4"
      @input="handleInput1"
      oninput="value=value.replace(/[^\d]/g,'')"
    />
    <RxkInput
      style="width: 70%; padding-left: 8px"
      v-model="innerValue2"
      type="text"
      :disabled="renderConfig.disabled"
      :placeholder="renderConfig.placeholder"
      :maxlength="8"
      @input="handleInput2"
      oninput="value=value.replace(/[^\d]/g,'')"
    />
  </template>
</template>
<script lang="ts" setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkInput } from '@/components/common/RxkInput'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const innerValue1 = ref('')
const innerValue2 = ref('')
function handleInput1() {
  innerValue.value = `${innerValue1.value}-${innerValue2.value}`
}

function handleInput2() {
  innerValue.value = `${innerValue1.value}-${innerValue2.value}`
}
onMounted(() => {
  if (innerValue.value) {
    dealData()
  }
})

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    nextTick(() => {
      dealData()
    })

    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
function dealData() {
  const arr = innerValue.value.split('-')
  innerValue1.value = arr[0] || ''
  innerValue2.value = arr[1] || ''
}
</script>
